import { useNavigate } from "react-router";
import { useContext, useState } from "react";
import myContext from "../../../Context/myContext";
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported

const AllProduct = () => {
    const navigate = useNavigate();
    const context = useContext(myContext);
    const { getAllProduct } = context;

    // State to manage search query
    const [searchQuery, setSearchQuery] = useState('');

    // Handle input change
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    // Filter products based on search query
    const filteredProducts = getAllProduct.filter(item =>
        item.title.toLowerCase().includes(searchQuery)
    );

    return (
        <div className="py-5">
            {/* Search Bar */}
            <div className="container mb-1">
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                        <div className="input-group mb-3" style={{ maxWidth: '400px' }}>
                            <span className="input-group-text bg-primary text-white">
                                <i className="fas fa-search"></i>
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search for products..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                                aria-label="Search"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Heading */}
            <div className="text-center mb-5">
                <h1 className="display-4 font-weight-bold">All Products</h1>
            </div>

            {/* Main Content */}
            <section className="container">
                <div className="row">
                    {filteredProducts.length > 0 ? (
                        filteredProducts.map((item, index) => {
                            const { id, title, price, productImageUrl } = item;
                            return (
                                <div key={index} className="col-md-4 mb-4">
                                    <div className="card border-0 shadow-sm h-100">
                                        {/* Image container with blue background */}
                                        <div
                                            className="card-img-top"
                                            style={{
                                                height: '300px', // Fixed height
                                                backgroundColor: '#cce5ff', // Blue background
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                padding: '10px' // Add padding for better visibility
                                            }}
                                        >
                                            <img
                                                onClick={() => navigate(`/productinfo/${id}`)}
                                                className="img-fluid cursor-pointer"
                                                src={productImageUrl}
                                                alt={title}
                                                style={{
                                                    maxHeight: '100%', // Image won't exceed the container height
                                                    objectFit: 'contain' // Ensure the image is fully visible
                                                }}
                                            />
                                        </div>
                                        <div className="card-body d-flex flex-column">
                                            <h5 className="card-title mb-2">
                                                {title.length > 25 ? `${title.substring(0, 25)}...` : title}
                                            </h5>
                                            <p className="card-text mb-3">
                                                {price}
                                            </p>
                                            <button
                                                className="btn btn-primary w-100 mt-auto"
                                                onClick={() => navigate(`/productinfo/${id}`)}
                                                type="button"
                                            >
                                                Learn More
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="col-md-12 text-center">
                            <p>No products found.</p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default AllProduct;
